import React from 'react';
import '../css/editContentBreadcrumb.css';
import {
  EditContentHomeIcon,
  EditContentIcon,
} from '../../../../../../asset-controller-mod/asset-serv/icons/iconExporter';

type BreadcrumbItem = {
  icon?: React.ReactNode;
  label: string;
  onClick?: () => void;
  active?: boolean; // true = current page (#2388FF)
};

type Props = {
  onHomeClick?: () => void;
  onContentClick?: () => void;
  /** Extra crumbs appended after "Content", e.g. ["Product", "Edit section"] */
  extra?: BreadcrumbItem[];
};

const EditContentBreadcrumb: React.FC<Props> = ({
  onHomeClick,
  onContentClick,
  extra = [],
}) => {
  const items: BreadcrumbItem[] = [
    { icon: <EditContentHomeIcon />, label: 'Home', onClick: onHomeClick },
    { icon: <EditContentIcon />, label: 'Content', onClick: onContentClick },
    ...extra,
  ];

  return (
    <nav
      className="scl--cms-content-edit-product-breadcrumb"
      aria-label="Breadcrumb"
    >
      {items.map((item, i) => (
        <React.Fragment key={item.label}>
          <button
            type="button"
            className={[
              'scl--cms-content-edit-product-breadcrumb-item',
              item.active ? 'scl--cms-content-edit-product-breadcrumb-item--active' : '',
            ].filter(Boolean).join(' ')}
            onClick={item.onClick}
            disabled={!item.onClick}
            aria-current={item.active ? 'page' : undefined}
          >
            {item.icon}
            <span>{item.label}</span>
          </button>

          {/* Separator — not after the last item */}
          {i < items.length - 1 && (
            <span className="scl--cms-content-edit-product-breadcrumb-sep" aria-hidden="true">
              /
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default EditContentBreadcrumb;